const styles = (theme) => ({
  itemsContainer: {
    display: 'grid',
    justifyItems: 'center',
  },
})

export default styles
